module.exports = __webpack_public_path__ + "img/甘肃都市调频_02.ce73131b.jpg";